<template>
  <div>
    <b-tabs lazy>
      <b-tab title="Data" disabled></b-tab>
      <b-tab title="Details" title-link-class="text-info">
        <ulu-inquiry-order-comparing-chart />
      </b-tab>
      <b-tab title="Cumulative" title-link-class="text-info">
        <ulu-inquiry-order-cumulative-chart />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
export default {
  components: {
    "ulu-inquiry-order-comparing-chart": () =>
      import("@/components/dashboard/inquiry_order/InquiryOrderComparingChart.vue"),
    "ulu-inquiry-order-cumulative-chart": () =>
      import("@/components/dashboard/inquiry_order/InquiryOrderCumulativeChart.vue")
  }
};
</script>
